import * as Sentry from '@sentry/react'

type SentryEnv = Pick<ImportMetaEnv, 'MODE' | 'DEV' | 'PROD' | 'SSR' | 'BASE_URL'> & {
  VITE_SENTRY_DSN?: string
  VITE_SENTRY_ENVIRONMENT?: string
  VITE_SENTRY_TRACES_SAMPLE_RATE?: string
}

// Sentry 10's PII_HEADER_SNIPPETS, applied when `sendDefaultPii` was false.
const PII_KEY_SNIPPETS = ['forwarded', '-ip', 'remote-', 'via', '-user']

export function initializeSentry(env: SentryEnv = import.meta.env): boolean {
  const dsn = env.VITE_SENTRY_DSN
  if (!dsn) {
    return false
  }

  const sampleInput = env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0'
  const sampleRate = Number(sampleInput)

  Sentry.init({
    dsn,
    environment: env.VITE_SENTRY_ENVIRONMENT ?? env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number.isFinite(sampleRate) ? sampleRate : 0,
    // Sentry 11 collects broadly by default. Keep the v10 `sendDefaultPii: false`
    // filters and v10 browser behaviour (no stack-frame variables or source context),
    // and opt out of cookies and GraphQL payloads entirely (stricter than v10).
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: { deny: PII_KEY_SNIPPETS },
      httpBodies: [],
      urlQueryParams: { deny: PII_KEY_SNIPPETS },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      queues: false,
      graphQL: { document: false, variables: false },
      stackFrameVariables: false,
      frameContextLines: 0,
    },
  })

  return true
}

initializeSentry()
